import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';

const styles = {
  container: {
    position: 'relative',
    top: '-30px'
  },
  dot: {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    borderRadius: '16px',
    border: '1.5px solid white',
    boxSizing: 'border-box',
    margin: '0 6px',
    padding: 0,
    cursor: 'pointer'
  },
  dotSelected: {
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.6)',
    background: 'white'
  },
  dotUnselected: {
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.6), inset 0 0 2px 0 rgba(0, 0, 0, 0.6)',
    background: 'transparent'
  }
};

function CarouselDots(props) {
  const { Block } = UX2.Element;
  const { numSlides, selectedIndex, goToSlide } = props;

  return (
    <Block tag='span' style={ styles.container }>
      { [...Array(numSlides)].map((_, index) => (
        <Block
          key={ `dot-${index}` }
          style={{
            ...styles.dot,
            ...(index === selectedIndex ? styles.dotSelected : styles.dotUnselected)
          }}
          onClick={ () => goToSlide(index) }
        />
      )) }
    </Block>
  );
}

CarouselDots.propTypes = {
  classicLayout: PropTypes.bool,
  numSlides: PropTypes.number,
  goToSlide: PropTypes.func,
  selectedIndex: PropTypes.number,
  currentAssetIndex: PropTypes.number,
  assetChangedByVariantSelection: PropTypes.any,
  hasMoreThanOneProduct: PropTypes.bool
};

export default CarouselDots;
